export const MESSAGE_FILE_FIELD_NAME: string = "fileUp";
export const MESSAGE_UP_URL: string = "message/file/up";
